import { API_URL } from '../../constants';

export const PAGINATION_PER_PAGE = 20;
export const POINT_CHOICES = [0,1,2,3,4,5,6,7,8,9,10];
export const API_MODEL_TYPE_COMPANY = 'company';
export const COMPANIES_API_PATH = `${API_URL}/companies`;
